/**
 * API Configuration
 * Centralized API URL configuration for the application
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:4032');
